import { Component, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: 'app-recommendation-metric',
  templateUrl: './recommendation-metric.component.html',
  styleUrl: './recommendation-metric.component.scss',
  standalone: false
})
export class RecommendationMetricComponent implements OnInit, OnDestroy {
  @Input() metric: any;
  @Input() therapyRecommendation: any;

  recommendationValueText: string = "";

  ngOnInit(): void { 
    this.setRecommendationValue();
  }

  setRecommendationValue() {
    if (this.therapyRecommendation?.length == 0) {
      return;
    }

    const recommendationSettings = this.therapyRecommendation[0].settings;
    const recommendationValue = recommendationSettings[this.metric.MetricId];

    if (!recommendationValue) {
      this.recommendationValueText = 'ptcs-v1-metric-value-na';
    }
    else if (this.metric.StringPrefix != "") {
      this.recommendationValueText = `${this.metric.StringPrefix}${recommendationValue.toLowerCase()}`
    } else {
      this.recommendationValueText = recommendationValue;
    }
  }

  ngOnDestroy(): void {
  }
}